class CalcSettingUtils {

    clone(calcSetting) {
        return Object.assign({}, calcSetting);
    }

    empty() {
        return {
            id: null,
            fieldType: "PROTECTION_AREA_BLMSCHV",
            resolution: 500,
            preferFarField: true,
            environmentFactor: 1,
            imageSetting: {
                colorScale: "RGB",
                marker: "SMALL",
                grid: "NONE",
                logScale: false,
                colorScaleAuto: true,
                colorScaleLowerLimit: null,
                colorScaleUpperLimit: null,
            }
        };
    }
}
const calcSettingUtils = new CalcSettingUtils();
export default calcSettingUtils;